// routes
import {PATH_DASHBOARD} from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import InventoryIcon from '@mui/icons-material/Inventory';
import PaymentsIcon from '@mui/icons-material/Payments';

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}}/>;

const ICONS = {
    user: getIcon('ic_user'),
};

const navConfig = [
    {
        subheader: 'Dashboard',
        items: [
            {
                title: 'Plugins',
                icon: <InventoryIcon/>,
                path: PATH_DASHBOARD.plugins.all
            },
            {
                title: 'Subscriptions',
                icon: <PaymentsIcon/>,
                path: PATH_DASHBOARD.subscriptions.all
            },
        ]
    }
];

export default navConfig;
